// components/common/advance-table/CustomPaginationFooter.jsx
import React from "react";
import { Form } from "react-bootstrap";
import AdvanceTableFooter from "components/common/advance-table/AdvanceTableFooter";

const CustomPaginationFooter = ({
  table,
  totalEntries = 0,
  loading = false,
  pageSizeOptions = [10, 25, 50, 100],
  showInfo = true,
  showPageSize = true,
  showNavigation = true,
}) => {
  const { pageIndex, pageSize } = table.getState().pagination;
  const startEntry = totalEntries === 0 ? 0 : pageIndex * pageSize + 1;
  const endEntry = Math.min((pageIndex + 1) * pageSize, totalEntries);

  return (
    <div className="mt-3 border-top bg-light rounded-bottom">
      <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center px-3 py-3 gap-3">

        {/* Left: Show entries dropdown */}
        {showPageSize && (
          <div className="d-flex align-items-center gap-2 text-muted small text-nowrap">
            <span>Show</span>
            <Form.Select
              size="sm"
              style={{ width: "80px" }}
              value={pageSize}
              onChange={(e) => table.setPageSize(Number(e.target.value))}
              disabled={loading}
            >
              {pageSizeOptions.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </Form.Select>
            <span>entries</span>
          </div>
        )}

        {/* Center: Showing X–Y of Z */}
        {showInfo && (
          <div className="text-muted small text-center flex-grow-1">
            {loading ? (
              "Loading..."
            ) : totalEntries > 0 ? (
              <>
                Showing <strong>{startEntry}–{endEntry}</strong> of{" "}
                <strong>{totalEntries.toLocaleString()}</strong> entries
           
              </>
            ) : (
              "No entries found"
            )}
          </div>
        )}

        {/* Right: Navigation */}
        {showNavigation && (
          <div>
            <AdvanceTableFooter
              table={table}
              navButtons
              rowInfo={false}
              rowsPerPageSelection={false}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomPaginationFooter;